module.exports = __webpack_public_path__ + "img/class6.cbb0a0bc.webp";